export default __webpack_public_path__ + "static/media/team3.a0d3f8a1.jpg";